import { render, staticRenderFns } from "./EmailValidated.vue?vue&type=template&id=be3b8ac8&"
import script from "./EmailValidated.vue?vue&type=script&lang=js&"
export * from "./EmailValidated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports